export default class TruncateElementMaster {
  static initialize() {
    const hasTable = $('.items-table-wrapper').length > 0;
    const hasTruncates = $('.truncate-container').length > 0;
    if (!hasTable || !hasTruncates) return;

    const hasPagination = $('.pagination-container').length > 0;
    const $actionsContainer = hasPagination ? $('.table-actions') : $('.items-toolbar .table-actions');

    const linkTemplate = (isExpand = true) =>
      `<div class="toggle-master-link-container">
        <a class="${isExpand ? 'expand-cards-master-link' : 'collapse-all-cards-master-link'} toggle-master-link">
          ${isExpand ? 'Expand All' : 'Collapse All'}
        </a>
      </div>`;

    const applyLinkStyles = () => {
      const styles = { display: 'flex' };

      if (hasPagination) {
        styles.marginRight = '1em';
      } else {
        styles.marginLeft = 'auto';
      }

      $('.toggle-master-link-container').css(styles);
    };

    // Insert the initial "Expand All" toggle link into the table actions toolbar
    $actionsContainer.prepend(linkTemplate(true));
    applyLinkStyles();

    // Toggle click handler
    $(document).on('click', '.toggle-master-link', function (e) {
      e.preventDefault();

      const isExpanding = $(this).hasClass('expand-cards-master-link');

      // Replace link with the opposite state
      const $newLink = $(linkTemplate(!isExpanding));
      $('.toggle-master-link-container').replaceWith($newLink);
      applyLinkStyles();

      // Trigger click on the appropriate action
      $(isExpanding ? '.read-more' : '.read-less').trigger('click');
    });

    // Remove toggle link for Unassigned Circle table
    $('.circle-table2').closest('form').find('.toggle-master-link-container').remove();
  }
}
